const plates = require("./plates")
const deliveryPrices = require("./delivery-prices")
const { docs } = require("./docs")
const { licenses } = require("./licenses")
const { comprehensiveInsurance } = require("../multi-city/comprehensive-insurance")

const ogun = {
  city: "ogun",
  areas: [],
  plates,
  docs,
  licenses,
  deliveryPrices,
  comprehensiveInsurance,
}

module.exports = ogun
